const FormLabelInput = ({ children }) => {
  return (
    <label className="text-secondary capitalize font-ubuntuBold flex justify-start">
      {children}
    </label>
  );
};

export default FormLabelInput;
